import "../css/style.scss";

// Our modules / classes
//import MobileMenu from "./modules/MobileMenu";
import GoogleMap from "./modules/GoogleMap";
import EditCharity from "./modules/EditCharity";
import MemberpressForm from "./modules/MemberpressForm";
import RegisterCharity from "./modules/RegisterCharity";
import SearchCharitiesFront from "./modules/SearchCharitiesFront";
import CausesManagement from "./modules/CausesManagement";
import SendEmail from "./modules/SendEmail";
import UpCircle from "./modules/UpCircle";

// Instantiate a new object using our modules/classes
//const mobileMenu = new MobileMenu();
const googleMap = new GoogleMap();
const editCharity = new EditCharity();
const memberpressForm = new MemberpressForm();
const registerCharity = new RegisterCharity();
const searchCharitiesFront = new SearchCharitiesFront();
const causesManagement = new CausesManagement();
const sendEmail = new SendEmail();
const upCircle = new UpCircle();
